import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import FormPasswordField from "components/form/form-password-field";

const ChangePassword = ({ intl, values, handleChange }) => (
  <>
    <DataGrid>
      <DataGridItem>
        <FormPasswordField
          id="oldPassword"
          name="oldPassword"
          value={values.oldPassword}
          onChange={handleChange}
          label={intl.formatMessage({ id: "app.page.user.currentPassword" })}
          autoComplete="currentPassword"
        />
      </DataGridItem>
    </DataGrid>
    <DataGrid>
      <DataGridItem>
        <FormPasswordField
          showRequirements
          id="newPassword"
          name="newPassword"
          value={values.newPassword}
          onChange={handleChange}
          label={intl.formatMessage({ id: "app.page.user.newPassword" })}
          autoComplete="newPassword"
        />
      </DataGridItem>
      <DataGridItem>
        <FormPasswordField
          marginDense
          id="confirmNewPassword"
          name="confirmNewPassword"
          value={values.confirmNewPassword}
          onChange={handleChange}
          label={intl.formatMessage({ id: "app.page.user.confirmNewPassword" })}
          autoComplete="newPassword"
        />
      </DataGridItem>
    </DataGrid>
  </>
);

ChangePassword.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(ChangePassword);
